import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';

const ButtonContainer = styled(motion.a)`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #25D366;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(37, 211, 102, 0.3);
  z-index: 1000;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 15px 40px rgba(37, 211, 102, 0.4);
  }

  svg {
    font-size: 2rem;
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    bottom: 1rem;
    right: 1rem;

    svg {
      font-size: 1.5rem;
    }
  }
`;

const Tooltip = styled(motion.span)`
  position: absolute;
  right: 70px;
  background: white;
  color: #333;
  padding: 0.5rem 1rem;
  border-radius: 30px;
  font-size: 0.9rem;
  font-weight: 500;
  white-space: nowrap;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  pointer-events: none;

  &::after {
    content: '';
    position: absolute;
    right: -5px;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid white;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const WhatsAppButton = () => {
  const phoneNumber = '9009206707';
  const message = encodeURIComponent('Hi! I have a question about Kemlo candies.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <ButtonContainer
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, rotate: -180 }}
      animate={{ scale: 1, rotate: 0 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      transition={{ type: "spring", stiffness: 260, damping: 20 }}
    >
      <FaWhatsapp />
      <Tooltip
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 1 }}
      >
        Chat with us!
      </Tooltip>
    </ButtonContainer>
  );
};

export default WhatsAppButton;